import { render, staticRenderFns } from "./CalendargroupCrud.vue?vue&type=template&id=4f8389b0"
import script from "./CalendargroupCrud.vue?vue&type=script&lang=js"
export * from "./CalendargroupCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports